import { render, staticRenderFns } from "./Entrepot.vue?vue&type=template&id=2dc28582&scoped=true"
import script from "./Entrepot.vue?vue&type=script&lang=js"
export * from "./Entrepot.vue?vue&type=script&lang=js"
import style0 from "./Entrepot.vue?vue&type=style&index=0&id=2dc28582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc28582",
  null
  
)

export default component.exports